/* eslint-disable prettier/prettier */
import * as Yup from 'yup';
import YupPassword from 'yup-password';
import { DEFAULT_COUNTRY_CODE } from '@constants/constants';

const phoneRegex = new RegExp(/^(\+|)([0-9]+)$/);

YupPassword(Yup);

export const businessAccount = Yup.object().shape({
  manualAddressSelection: Yup.boolean().default(false),
  registrationNr: Yup.string()
    .when('countryCode', {
      is: (countryCode: string) => {
        return countryCode === DEFAULT_COUNTRY_CODE;
      },
      then: (schema) => schema.required('form-errors:required.coc-number').matches(/^[0-9]{8}$/, { message: 'matches.coc-number' })
    })
    .default(''),
  vatRegistrationNr: Yup.string()
    .when('countryCode', {
      is: (countryCode: string) => {
        return countryCode !== DEFAULT_COUNTRY_CODE;
      },
      then: (schema) => schema.min(4, 'form-errors:required.vat-number')
    })
    .default(''),
  companyName: Yup.string().required('form-errors:required.company-name').min(2).default(''),
  postalCode: Yup.string().required('form-errors:required.postal-code').default(''),
  houseNumber: Yup.string()
    .matches(/.*\d.*/, { excludeEmptyString: true, message: 'form-errors:required.house-number' })
    .required('form-errors:required.house-number')
    .default(''),
  houseNumberAddition: Yup.string().default(''),
  street: Yup.string().required('form-errors:required.street').default(''),
  city: Yup.string().required('form-errors:required.city').default(''),
  hasDeliveryAddress: Yup.boolean().default(false),
  manualDeliveryAddress: Yup.boolean().default(false),
  deliveryPostalCode: Yup.string()
    .when('hasDeliveryAddress', {
      is: true,
      then: (schema: any) => schema.required('form-errors:required.delivery-postal-code')
    })
    .default(''),
  deliveryHouseNumber: Yup.string()
    .when('hasDeliveryAddress', {
      is: true,
      then: (schema: any) =>
        schema
          .matches(/.*\d.*/, { excludeEmptyString: true, message: 'form-errors:required.delivery-house-number' })
          .required('form-errors:required.house-number')
          .default('')
    })
    .default(''),
  deliveryHouseNumberAddition: Yup.string().default(''),
  deliveryStreet: Yup.string()
    .when('hasDeliveryAddress', {
      is: true,
      then: (schema: any) => schema.required('form-errors:required.delivery-street')
    })
    .default(''),
  deliveryCity: Yup.string()
    .when('hasDeliveryAddress', {
      is: true,
      then: (schema: any) => schema.required('required.delivery-city')
    })
    .default(''),
  firstName: Yup.string().required('form-errors:required.first-name').default(''),
  lastName: Yup.string().required('form-errors:required.last-name').default(''),
  emailAddress: Yup.string().email('matches.email').required('required.email').default(''),
  phoneNumber: Yup.string().matches(phoneRegex, { message: 'form-errors:matches.phone-number', excludeEmptyString: true }).default(''),
  countryCode: Yup.string().required('form-errors:required.country').default(DEFAULT_COUNTRY_CODE)
});

export type businessAccountFormValues = Yup.InferType<typeof businessAccount> | Yup.InferType<typeof loginData>;

export const loginData = Yup.object().shape({
  username: Yup.string().required('form-errors:required.choose-a-username').default(''),
  password: Yup.string()
    .required('form-errors:required.password')
    .min(12, 'form-errors:min-length.password')
    // .minLowercase(1, 'Your password must contain at least 1 lower case letter')
    // .minUppercase(1, 'Your password must contain at least 1 upper case letter')
    // .minNumbers(1, 'Your password must contain at least 1 number')
    .default(''),
  repeatPassword: Yup.string()
    .required('form-errors:required.repeat-password')
    .oneOf([Yup.ref('password')], 'form-errors:passwords-do-not-match')
    .default('')
});
